import {AppForm} from '../../../../../../../common/forms/app.form';
import {Injectable} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {CustomValidator, fromToDate} from '../../../../../../../common/forms/custom.validators';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  VehicleAppEntityVehicleWrite
} from '../../../../../../../openapi';
import {VehicleForm} from './vehicle-form';

@Injectable()
export class PermitForOversizeVehicleTravelDataForm extends AppForm {
  constructor() {
    super({
      startDate: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            CustomValidator.isValidDateFormat(),
            CustomValidator.minDate(new Date())
          ]
        }),
      endDate: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            CustomValidator.isValidDateFormat()
          ]
        })
    }, {
      validators: [
        fromToDate('startDate', 'endDate')
      ]
    });
  }

  public get startDate(): FormControl {
    return this.get('startDate') as FormControl;
  }

  public get endDate(): FormControl {
    return this.get('endDate') as FormControl;
  }

  public get vehicleForm(): VehicleForm | null {
    return this.get('vehicleForm') as VehicleForm | null;
  }

  public get vehicleValues(): VehicleAppEntityVehicleWrite[] {
    return this.vehicleForm?.value ? [this.vehicleForm.value] : [];
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.vehicles;
    return value;
  }

  private setEndDateByTransitPeriod(v: string): void {
    const d = new Date();

    switch (v) {
      case '1 miesiąc': {
        d.setMonth(d.getMonth() + 1);
        break;
      }
      case '6 miesięcy': {
        d.setMonth(d.getMonth() + 6);
        break;
      }
      case '12 miesięcy': {
        d.setMonth(d.getMonth() + 12);
        break;
      }
      case '24 miesięcy': {
        d.setMonth(d.getMonth() + 24);
        break;
      }
    }

    this.endDate.setValue(d);
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead) {
    switch (value?.applicationSubject) {
      case 'Kategorii II': {
        this.setEndDateByTransitPeriod(value?.transitPeriod || '');
        break;
      }
      case 'Kategorii I': {
        const d = new Date();
        d.setMonth(d.getMonth() + 12);
        this.endDate.setValue(d);

        this.addControl('vehicleForm', new VehicleForm());
        break;
      }
    }
    this.vehicleForm?.patchFormValues(value?.vehicles?.at(0))
    super.patchFormValues(value);
  }
}
